import React, { useCallback } from "react";

import { useSelector, useDispatch } from "react-redux";

// import HowToPlay from './modals/HowToPlay';
// import Login from './modals/Login';
import Winner from './modals/Winner';
import HamburgerMenu from "./modals/HamburgerMenu";
import LoadingScreen from "./modals/LoadingScreen";
// import NewsieCategories from './modals/NewsieCategories';
// import ConfirmationModal from './modals/ConfirmationModal';
// import GetNewsiePlus from './modals/GetNewsiePlus';
// import SetPassword from './modals/SetPassword';
// import UpdateUsername from './modals/UpdateUsername';

import "./Modal.css";
import { dismissModal } from "Store/features/stateSlice";
import { dismissPublicModal } from "Store/features/public/publicStateSlice";
import CreateAccount from "./modals/CreateAccount";
import PuzzleGenieLogin from "./modals/PuzzleGenieLogin";
import ConfirmationModal from "./modals/ConfirmationModal";

// Modals
const HOW_TO_PLAY = "HOW_TO_PLAY";
const LOGIN = "LOGIN";
const WINNER = "WINNER";
const HAMBURGER_MENU = "HAMBURGER_MENU";
const LOADING = "LOADING";
const NEWSIE_CATEGORIES = "NEWSIE_CATEGORIES";
const CONFIRMATION_MODAL = "CONFIRMATION_MODAL";
const GET_NEWSIE_PLUS = "GET_NEWSIE_PLUS";
const SET_PASSWORD = "SET_PASSWORD";
const UPDATE_USERNAME = "UPDATE_USERNAME";
const CREATE_ACCOUNT = 'CREATE_ACCOUNT';
const PUZZLE_GENIE_LOGIN = 'PUZZLE_GENIE_LOGIN';

const CONFIRM_USER_DELETE = "CONFIRM_USER_DELETE";

export const CONFIRMATION_MODAL_VARIANTS = {
  [CONFIRM_USER_DELETE]: CONFIRM_USER_DELETE,
};

export const MODALS = {
  HOW_TO_PLAY: HOW_TO_PLAY,
  LOGIN: LOGIN,
  WINNER: WINNER,
  CREATE_ACCOUNT: CREATE_ACCOUNT,
  HAMBURGER_MENU: HAMBURGER_MENU,
  LOADING: LOADING,
  NEWSIE_CATEGORIES: NEWSIE_CATEGORIES,
  CONFIRMATION_MODAL: CONFIRMATION_MODAL,
  GET_NEWSIE_PLUS: GET_NEWSIE_PLUS,
  SET_PASSWORD: SET_PASSWORD,
  UPDATE_USERNAME: UPDATE_USERNAME,

  PUZZLE_GENIE_LOGIN: PUZZLE_GENIE_LOGIN
};

const modalToCssMap = {
  NEWSIE_CATEGORIES: "newsie-categories",
  HOW_TO_PLAY: "how-to-play",
  LOGIN: "login",
  WINNER: "winner",
  CREATE_ACCOUNT: 'create-account',
  HAMBURGER_MENU: "hamburger-menu",
  LOADING: "loading",
  CONFIRMATION_MODAL: "confirmation-modal",
  GET_NEWSIE_PLUS: "get-newsie-plus",
  SET_PASSWORD: "set-password",
  UPDATE_USERNAME: "update-username",
  PUZZLE_GENIE_LOGIN: 'puzzle-genie-login'
};

const modalToComponentMap = {
  // [HOW_TO_PLAY]: () => <HowToPlay skipExitButton />,
  // [LOGIN]: () => <Login />,
  [WINNER]: () => <Winner />,
  [CREATE_ACCOUNT]: () => <CreateAccount />,
  [HAMBURGER_MENU]: () => <HamburgerMenu />,
  [LOADING]: () => <LoadingScreen />,
  [PUZZLE_GENIE_LOGIN]: () => <PuzzleGenieLogin />,


  // [NEWSIE_CATEGORIES]: () => <NewsieCategories />,
  [CONFIRMATION_MODAL]: () => <ConfirmationModal />,
  // [GET_NEWSIE_PLUS]: () => <GetNewsiePlus />,
  // [SET_PASSWORD]: () => <SetPassword />,
  // [UPDATE_USERNAME]: () => <UpdateUsername />
};

const Modal = (props) => {
  const { isPublic } = props;
  const dispatch = useDispatch();
  const variant = useSelector((state) => state.stateSlice.dynamicModalVariant);
  const handleClickCloseModalX = useCallback(
    (e) => {
      e.stopPropagation();
      if (isPublic) {
        dispatch(dismissPublicModal());
      } else {
        dispatch(dismissModal());
      }
    },
    [isPublic]
  );
  const {
    shouldShowModal = true,
    modal,
    shouldDismissModal,
    onDismissModal = handleClickCloseModalX,
  } = props;
  console.log({modal})
  const className = `Modal ${
    shouldShowModal && !shouldDismissModal ? "show" : ""
  } ${modalToCssMap[modal]} ${shouldDismissModal ? "disappear" : ""}`;
  const ModalContent = modalToComponentMap[modal];

  const backgroundClassName = `${
    shouldShowModal && !shouldDismissModal ? "bg" : ""
  }`;
  return (
    <div className={backgroundClassName} onClick={onDismissModal}>
      <div className={className}>
        {modal !== "HOW_TO_PLAY" && (
          <div className="modal-x-container" onClick={handleClickCloseModalX}>
            X
          </div>
        )}
        {ModalContent && <ModalContent />}
      </div>
    </div>
  );
};

export default Modal;
